import {ChangeBorrowCheckContainer} from "../../../containers/borrowSystem/ChangeAndExtendBorrowForm/ChangeBorrowCheckContainer"
export function ChangeBorrowCheckPage () {
    return(
        <ChangeBorrowCheckContainer/>
    )
}